export const AGENT_ROLES = [
  { label: 'Member', value: 'member' },
  { label: 'Solo', value: 'solo' },
  { label: 'Lead', value: 'team_lead' },
];
